import React from "react";

const Button = ({ children }) => {
  return (
    <div>
      {/* <button class="btn btn-primary bg-gradient-to-r from-secondary to-primary ">
        {children}
      </button> */}
      <button class="btn btn-primary bg-cyan-800 text-white ">
        {children}
      </button>
    </div>
  );
};

export default Button;
